import type { LocationQuery } from 'vue-router'

export const SSR_QUERY = {
    CLID: 'clid',
    EXPORT_MODE: 'export_mode',
    GAME_DISTRIBUTION: 'use_gd_ads',
    DEBUG: 'debug',
    AUTOPLAY: 'autoplay',
    BACKEND_FLAGS: 'backend_flags',
    SHOW_HIDDEN: 'show_hidden',
    AUDIENCE: 'audnc',
    REDIRECT_COUNTER: 'redirCnt',
    TRUNCATE_LCP: 'truncate_lcp',
    PAGE: 'page',
    PINNED_GAME: 'pinned_game',
    SEARCH_QUERY: 'q',
    DOMAIN: 'domain',
    AD_SDK_CONFIG_ID: 'config_id',
    DEVTOOLS: 'pg_devtools',
} as const

export const SERVER_QUERY = {
    SKIP_PLATFORM_DETECTION: 'skip_pd',
    EXPERIMENT: 'exp',
    LOCALE: 'locale',
    UTM_SOURCE: 'utm_source',
    UTM_MEDIUM: 'utm_medium',
    UTM_CAMPAIGN: 'utm_campaign',
    UTM_CAMPAIGN_ID: 'utm_campaign_id',
    UTM_TERM: 'utm_term',
    UTM_CONTENT: 'utm_content',
    WEB_APP_MANIFEST: 'web_app',
} as const

export const CLIENT_QUERY = {
    ESCAPED_FROM_WEBVIEW: 'efw',
    FORCE_HANDOFF: 'force_safari',
    USE_NO_ADS: 'use_no_ads',
    DSP_CLICK_ID: 'pgclid',
    LEGACY_DSP_CLICK_ID: 'pg_dsp_click_id',
    AUTHORIZATION_ID: 'authorization_id',
    FROM: 'from',
    PORTAL_SEARCH_QUERY: 'portal_search_query',
    WIDGET_ID: 'widget_id',
    GAME_PAYLOAD: 'payload',
    GAME_DISTRIBUTION_GAME_ID: 'gd_game_id',
    GAME_ID: 'game_id',
    GAME_PLATFORM: 'platform',
} as const

export const PG_QUERY_START = '__pg_start__'
export const PG_QUERY_END = '__pg_end__'

export const EXP_OVERRIDE_PREFIX = 'exp_'
export const UTM_PREFIX = 'utm_'

const MAX_PAGE = 1_000_000

export const parsePageQuery = (query: LocationQuery): number => {
    if (!(SSR_QUERY.PAGE in query)) {
        return 1
    }

    const rawPage = query[SSR_QUERY.PAGE]
    if (typeof rawPage === 'string' && /^[1-9]\d*$/.test(rawPage)) {
        const page = parseInt(rawPage, 10)
        if (page < MAX_PAGE) {
            return page
        }
    }

    return NaN
}

export const pageQuery = (page: number) => (page > 1 ? { [SSR_QUERY.PAGE]: page } : {})

export const isDebugQueryEnabled = (value: unknown): boolean =>
    Array.isArray(value) ? value.some(Boolean) : Boolean(value)

export const isDevtoolsQueryEnabled = (value: unknown): boolean => value !== undefined && value !== '0'

const REDIRECT_MAX_COUNT = 5

export const addRedirectCounter = (url: URL) => {
    const redirCnt = parseInt(url.searchParams.get(SSR_QUERY.REDIRECT_COUNTER) || '0')

    if (redirCnt > REDIRECT_MAX_COUNT) {
        return
    }

    url.searchParams.set(SSR_QUERY.REDIRECT_COUNTER, (redirCnt + 1).toString())

    return url
}
